<template>
    <div class="headerShowClass">
        <div class="flexLine">
            <div class="logoIMGclass" @click="goToHome"></div>
            <div class="menuTitles">
                <div class="homeLogo"></div>
                <div class="headerTitle" @click="goToPageFN('1-1')">{{$t("indexVal")}}</div>
                <div class="headerTitle" @click="goToPageFN('1-2')">{{$t("modelList")}}</div>
                <div class="headerTitle" @click="goToPageFN('1-3')">{{$t("modelReport")}}</div>
                <div class="headerTitle" @click="goToPageFN('1-news')">{{$t("newsVal")}}</div>
                <div class="headerTitle" v-for="(item,index) in restDataArr" :key="index" @click="goToPageFN('1-'+(4+index),item)">{{item.title}}</div>

            </div>
            <div class="rightLine" style="position: relative;">
                <div class="pcShow searchColorSet" @click="submitQuery">
                    <Icon type="ios-search" />
                </div>
                <!-- <div class="searchClass pcShow">
                     <Input prefix="ios-search" v-model="queryModel" :placeholder="$t('allSearch')" style="width: auto" />
                    <div class="selectOption marginRightClass">
                        <Button type="info" @click="submitQuery">{{$t("queryVal")}}</Button>
                    </div>
                </div> -->
                <div class="phoneShow" @click="submitQuery">
                    <Icon type="ios-search" />
                </div>
                <Select v-model="language" style="width:100px" @on-change="changeLangFn">
                    <Option v-for="item in languageList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
                <div @click="showLogOutFN" v-if="peoName" class="logInClass logOutClass">
                    <div class="logOutModel" v-show="logOutShow">
                        <Button type="primary" @click="logOutFN">退出登录</Button>
                    </div>
                    {{peoName}}</div>
                <div @click="registerFN" v-else class="logInClass">{{$t("registe")}}</div>

            </div>
            <div class="phoneMenu">
                <div class="upMenuClick" @click="clickMenuFN"></div>
                <Menu mode="horizontal" ref="menuChild" @on-select="goToPageFN" :active-name="selected" :open-names="openname">
                    <Submenu name="1">
                        <template slot="title">
                            <Icon type="ios-list-box" />
                        </template>
                        <!-- title="" -->
                        <MenuGroup >
                            <MenuItem name="1-1">{{$t("indexVal")}}</MenuItem>
                            <MenuItem name="1-2">{{$t("modelList")}}</MenuItem>
                            <MenuItem name="1-3">{{$t("modelReport")}}</MenuItem>

                            <MenuItem :name="'1-'+(indexs+4)" v-for="(item,indexs) in restDataArr" :key="indexs">{{item.title}}</MenuItem>
                            <MenuItem name="1-news">{{$t("newsVal")}}</MenuItem>
                            <MenuItem name="1-end">{{peoName?peoName:$t("registe")}}</MenuItem>
                        </MenuGroup>
                    </Submenu>

                </Menu>
                <!-- <Icon type="ios-list-box" /> -->
            </div>

        </div>
        <Modal
            :footer-hide='true'
            v-model="registerModal"
            :title="$t('registe')">
            <div class="registTitle">
                {{$t('welcome')}}
            </div>
            <div class="inputInClass">
                <span class="mustColor">*</span>
                <Input prefix="md-mail" class="mustOtherWidth" v-model="mailModel" :placeholder="$t('mailVal')"  />
            </div>
            <div class="inputInClass">
                <span class="mustColor">*</span>
                <Input prefix="ios-call" class="mustOtherWidth" v-model="phoneModel" :placeholder="$t('phoneVal')"  />
            </div>
            <div class="inputInClass">
                <span class="mustColor">*</span>
                <Input prefix="md-person" class="mustOtherWidth" v-model="peoModel" :placeholder="$t('userVal')"  />
            </div>
            <div class="inputInClass">
                <span class="mustColor">*</span>
                <Input prefix="ios-lock" class="mustOtherWidth" v-model="passwordModel" type="password" password :placeholder="$t('passwordVal')" />
            </div>
            <div class="inputInClass">
                <Input prefix="md-home" v-model="companyModel" :placeholder="$t('companVal')"  />
            </div>
            <div class="inputInClass">
                <Input prefix="ios-card" v-model="postModel" :placeholder="$t('leaderVal')"  />
            </div>
            <div class="inputInClass">
                <Checkbox label="twitter" v-model="readTxtModel">
                    <Icon type="logo-twitter"></Icon>
                    <span>{{$t('readBefore')}}
                        <router-link :to="{path:'/copyRight'}">{{$t('readTipNew')}}</router-link>
                        {{$t('readOld')}}
                        <router-link :to="{path:'/invisible'}">{{$t('readTipSec')}}</router-link>
                    </span>
                </Checkbox>
            </div>
            <div class="inputInClass">
                <Button @click="nextLoginFN">{{$t('nextStep')}}</Button>
            </div>
            <div class="signToClass">
                <div>{{$t('hasAccount')}}？<span class="loginInClass" @click="gotoLoginFN">{{$t('loginNow')}}</span></div>
            </div>
        </Modal>
        <Modal
            :footer-hide='true'
            v-model="loginrModal"
            :title="$t('loginVal')">
            <div class="registTitle">
                {{$t('welcomeBack')}}
            </div>

            <div class="inputInClass">
                <Input prefix="md-mail" v-model="peoLogModel" :placeholder="$t('mailVal')"  />
            </div>
            <div class="inputInClass">
                <Input prefix="ios-lock" v-model="passwordLogModel" type="password" password :placeholder="$t('passwordEnter')" />
            </div>

            <div class="inputInClass">
                <Button @click="loginInFN">{{$t('loginVal')}}</Button>
            </div>
            <div class="signToClass">
                <div>{{$t('noAccount')}}？<span class="loginInClass" @click="registerFN">{{$t('registNow')}}</span></div>
            </div>
        </Modal>
    </div>
</template>
<script>
import { registModeRequest, loginModeRequest, modelListRequest } from '../request/request'
export default {
  data () {
    return {
      logOutShow: false,
      queryModel: '',
      peoName: '',
      restDataArr: [],
      languageVal: 'ch',
      openname: [],
      selected: '',
      loginrModal: false,
      phoneModel: '',
      peoLogModel: '',
      passwordLogModel: '',
      readTxtModel: false,
      mailModel: '',
      peoModel: '',
      passwordModel: '',
      companyModel: '',
      postModel: '',
      registerModal: false,
      languageList: [
        {
          value: 'zh',
          label: '中文'
        },
        {
          value: 'en',
          label: 'English'
        }

      ],
      language: []
    }
  },
  mounted () {
    if (this.$i18n.locale) {
      this.language = this.$i18n.locale
    } else {
      this.language = 'zh'
    }
    this.languageVal = localStorage.getItem('language') === 'en' ? 'en' : 'ch'
    // this.language = this.$i18n.locale
    this.changeLangFn(this.language)
    this.$nextTick(() => {
    //   this.initFN()
    })
  },
  methods: {
    async loginModeRequestFN (e) {
      var res = await loginModeRequest(e)
      if (res.data.code === 0) {
        localStorage.contact = res.data.data.user.mobile
        localStorage.userName = res.data.data.user.name
        localStorage.tokenVal = res.data.data.token
        localStorage.userVal = res.data.data.user.id
        this.peoName = res.data.data.user.name
        this.registerModal = false
        this.loginrModal = false
        this.$Message.success('登录成功')
      } else {
        this.$Message.error('账号或密码错误')
      }
    },
    async registModeRequestFN (e) {
      var res = await registModeRequest(e)
      if (res.data.code === 0) {
        this.$Message.success('注册成功')
        this.gotoLoginFN()
      }
    },
    async modelListRequestFN (e) {
      var res = await modelListRequest(e)
      if (res.data.code === 0) {
        this.restDataArr = res.data.data
      }
    },
    logOutFN () {
      this.peoName = ''
      localStorage.authorization = ''
      localStorage.tokenVal = ''
      localStorage.userName = ''
      localStorage.userVal = ''
      this.logOutShow = false
    },
    showLogOutFN () {
      this.logOutShow = !this.logOutShow
    },
    submitQuery () {
      this.$router.push({
        path: `/allSearch`,
        query: {
          value: this.queryModel
        }
      })
    },
    goToHome () {
      this.$router.push({
        path: `/`
      })
    },
    clickMenuFN (e) {
      if (this.openname.length == 0) {
        this.openname = ['1']
        this.$nextTick(() => {
          this.$refs.menuChild.updateOpened()
        })
      } else {
        this.openname = []
        this.$nextTick(() => {
          this.$refs.menuChild.updateOpened()
        })
      }
      console.log(e)
    },
    goToPageFN (e, a) {
      localStorage.tagDataAll = ''
      console.log(e)
      console.log(a)
      if (e === '1-1') {
        this.$router.push({
          path: `/`
        })
      }
      if (e === '1-2') {
        localStorage.detailPage = 1
        this.$router.push({
          path: `/detail`
        })
      }
      if (e === '1-3') {
        localStorage.reportListPage = 1
        this.$router.push({
          path: `/reportList`
        })
      }
      if (e === '1-5') {
        localStorage.smgListPage = 1
        this.$router.push({
          path: `/smgDetail`
        })
      }
      if (e === '1-6') {
        localStorage.matchListPage = 1
        this.$router.push({
          path: `/matchList`
        })
      }
      if (e !== '1-1' && e !== '1-2' && e !== '1-3' && e !== '1-5' && e !== '1-6' && e !== '1-end' && e !== '1-news') {
        // if (a) {
        //   this.$router.push({
        //     path: `/reportList`,
        //     query: {
        //       contentType: a.contentType

        //     }
        //   })
        // } else {
        var index = parseInt(e.substring(e.length - 1, e.length)) - 4
        var itemVal = this.restDataArr[index]
        localStorage.reportListPage = 1
        this.$router.push({
          path: `/reportList`,
          query: {
            contentType: itemVal.contentType,
            id: itemVal.id
          }
        })
        // }
      }
      if (e === '1-news') {
        localStorage.newsListPage = 1
        this.$router.push({
          path: '/newsList',
          name: 'newsList'
        })
      }
      if (e === '1-end') {
        this.registerFN()
      }

      console.log(e)
    },
    loginInFN () {
      this.loginModeRequestFN({ account: this.peoLogModel, password: this.passwordLogModel })
    },
    nextLoginFN () {
      if (this.mailModel && this.peoModel && this.passwordModel && this.readTxtModel && this.phoneModel) {
        var dataObj = {
          'company': this.companyModel,
          'head': '',
          'id': '',
          'mail': this.mailModel,
          'mobile': this.phoneModel,
          'name': this.peoModel,
          'password': this.passwordModel,
          'status': 0,
          'title': this.postModel
        }
        this.registModeRequestFN(dataObj)
      } else {
        this.$Message.error('请补充完整注册信息')
      }
    },
    ok () {},
    cancel () {},
    gotoLoginFN () {
      this.registerModal = false
      this.loginrModal = true
    },
    registerFN () {
      this.loginrModal = false
      this.registerModal = true
    },
    changeLangFn (val) {
      this.$emit('changeLanguage', val)
      let chan = this.languageList

      for (let i in chan) {
        if (chan[i].value === val) {
          this.language = this.$i18n.locale = chan[i].value
          this.initFN()
          localStorage.setItem('language', chan[i].value)
        }
      }
    },
    initFN () {
      this.peoName = localStorage.userName ? localStorage.userName : ''
      this.modelListRequestFN({ lang: this.language })
    }
  }
}
</script>
<style lang="scss">
.logOutModel{
    position: absolute;

    bottom: -20px;
    right: 0px;
    width: 100px;
}
.logOutClass{
    position: relative;
}
.mustOtherWidth{
    width: 95% !important;
}
.mustColor{
    color: red;
}
    .searchColorSet{
        font-size: 30px;
        color: #40A0F0;
        margin-right: 20px;
    }
    .pcShow{
        display: flex;
    }
    .phoneShow{
        display: none;
    }
    .marginRightClass{
        margin-right: 15px;
    }
    .upMenuClick{
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 999;
    }
    .logoIMGclass{
        cursor: pointer;
        height: 100%;
        width: 13vw;
        margin-left: 3vw;
        margin-right: 0;
        @include containbackground;
        background-image: url('../assets/logoShow.jpg');
    }
    .phoneMenu{
        position: relative;
        height: 100%;
        padding-left: 0.5vw;
        font-size: 40px;
        color: #40A0F0;
        display: none;

        .ivu-menu-submenu-title{
            font-size: 45px;
        }
        .ivu-menu-submenu-title-icon{
            display: none;
        }
        .ivu-select-dropdown{
            width: 100vw !important;
            position: fixed !important;
            margin: 0 !important;
            left:0 !important
        }
        .ivu-menu-horizontal .ivu-menu-submenu .ivu-select-dropdown .ivu-menu-item{
            text-align: left;
            font-size: 18px !important;
        }
        .ivu-menu-item-group-title{
            display: none;
        }
        .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
        .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
        .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
        .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover{
            border-bottom:0px
        }
        .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item,
        .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu{
            color: #40A0F0;
        }
    }
    .homeLogo{
        @include containbackground;
        background-image: url('../assets/logoShow.jpg');
    }
    .menuTitles{
        width: 70%;
        @include aroundLine
    }
    .rightLine{

        width: 30%;
        height:100%;
        @include bottomLine
    }
    .headerTitle{
        color:#16161A;
        cursor:pointer
    }
    .headerTitle:hover{
        color: #40A0F0;
    }
    .loginInClass{
        color:#40A0F0;
        cursor: pointer;
    }
    .signToClass{
        @include bottomLine
    }
    .inputInClass .ivu-btn{
        width:100%;
        background:linear-gradient(90deg,rgba(64,160,240,1) 0%,rgba(122,189,245,1) 100%);
        opacity:1;
        color:white;
        border-radius:4px;
    }
    .inputInClass .ivu-input-prefix i,.inputInClass .ivu-input-suffix i{
        color:#40A0F0
    }
    .inputInClass .ivu-input{
        border-radius: 0px;
        border:0px;
        border-bottom:1.5px solid #40A0F0;
    }
    .registTitle{
        @include centerLine;
        font-size: 16px;
        font-weight: bold;
    }
    .inputInClass{
        padding:1.5vh 15%
    }
    .logInClass{
        cursor:pointer;
        color:black;
        margin:0 15px
    }
    .flexLine{
        height:100%;
        @include startLine
    }
    .headerShowClass{
        width:100%;
        height:100%
    }
</style>
<style>

</style>
